import router, { getRouterState } from "@/router"

import { reactive } from "vue"

// Is root is usually used for rendering, so better update it after navigation
const keysToUpdateAfterNavigation = ["isRoot"]

export default {
  install(app) {
    app.config.globalProperties.$routerState = reactive({
      ...getRouterState()
    })

    router.beforeEach((to, from, next) => {
      const state = getRouterState()
      Object.keys(state).filter((key) => !keysToUpdateAfterNavigation.includes(key)).forEach((key) => {
        app.config.globalProperties.$routerState[key] = state[key]
      })
      next()
    })

    router.afterEach(() => {
      const state = getRouterState()
      keysToUpdateAfterNavigation.forEach((key) => {
        app.config.globalProperties.$routerState[key] = state[key]
      })
    })
  }
}
